import TabContainer from "./TabContainer";
import { HomeTab, ChallengesTab, CreateTab, ProfileTab } from "../tabs";

function TabLayout() {
  return (
    <TabContainer
      homeTab={<HomeTab />}
      challengesTab={<ChallengesTab />}
      createTab={<CreateTab />}
      profileTab={<ProfileTab />}
    />
  );
}

export default TabLayout;
